import { Network, TaggedList } from '@movilizame/networking';
import { AuthApi } from './Auth';
import { UserApi } from './User';
import { CompanyApi } from './Company';
import { MensajesApi } from './MensajesApi';
import { PasajerosApi } from './PasajerosApi';
import { ChoferesApi } from './ChoferesApi';
import { PaymentsApi } from './Payments';

const API_URL = process.env.API_URL;

export const networkList = new TaggedList();

export const networking = new Network(API_URL);

export const apis = {
    authApi: new AuthApi(networking, networkList),
    userApi: new UserApi(networking, networkList),
    mensajesApi: new MensajesApi(networking, networkList),
    choferesApi: new ChoferesApi(networking, networkList),
    pasajerosApi: new PasajerosApi(networking, networkList),
    companyApi: new CompanyApi(networking, networkList),
    paymentsApi: new PaymentsApi(networking, networkList)
};



// WEBPACK FOOTER //
// ./src/services/api/index.js